import MultipleChoiceQuestionTemplate from '~/pages/anatomyV2/libs/components/MultipleChoiceQuestionTemplate'
import { MULTIPLE_CHOICE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/multipleChoiceCorrectAnswers'
import {
  bicepsPNG,
  bicepsWEBP,
  glutesPNG,
  glutesWEBP,
  heartPNG,
  heartWEBP,
  masseterPNG,
  masseterWEBP,
} from '~/pages/anatomyV2/strongestMuscle/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 3

const OPTIONS = [
  {
    key: 'heart',
    i18nKey: 'onboarding.strongestMuscle.options.heart',
    png: heartPNG,
    webp: heartWEBP,
  },
  {
    key: 'glutes',
    i18nKey: 'onboarding.strongestMuscle.options.glutes',
    png: glutesPNG,
    webp: glutesWEBP,
  },
  {
    key: 'masseter',
    i18nKey: 'onboarding.strongestMuscle.options.masseter',
    png: masseterPNG,
    webp: masseterWEBP,
  },
  {
    key: 'biceps',
    i18nKey: 'onboarding.strongestMuscle.options.biceps',
    png: bicepsPNG,
    webp: bicepsWEBP,
  },
]

const StrongestMuscleAnatomyV2 = (props: TPageProps) => (
  <MultipleChoiceQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.strongestMuscle.title"
    options={OPTIONS}
    correctOptionKey={
      MULTIPLE_CHOICE_CORRECT_ANSWERS[PageId.STRONGEST_MUSCLE_ANATOMY_V2_1]!
    }
    correctExplanationI18nKey="onboarding.strongestMuscle.correctExplanation"
    incorrectTitleI18nKey="onboarding.strongestMuscle.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.strongestMuscle.incorrectExplanation"
    question="Strongest muscle in the human body"
  />
)

export default StrongestMuscleAnatomyV2
